import React, { useState } from "react"
import Spacer from "../components/spacer"
import { Link, useStaticQuery, graphql } from "gatsby"

export default function Footer({ onSubscribeClick }) {
    const { footer } = useStaticQuery(graphql`
        query FooterQuery {
            footer: datoCmsFooter {
                address
                contactInfo
                acknowledgement
                newsletterTitle
                socialMedia {
                    title
                    link
                }
            }
        }
    `)

    return (
        <footer className='p40 m-p20 m-py40 pb20'>
            <div className='grid grid-3 m-hide'>
                <FirstColumn acknowledgement={footer.acknowledgement} />
                <SecondColumn footer={footer} newsletterCta={footer.newsletterTitle} onSubscribeClick={onSubscribeClick} />
                <ThirdColumn />
            </div>
            <FooterMobile footer={footer} newsletterCta={footer.newsletterTitle} onSubscribeClick={onSubscribeClick} />
        </footer>
    )
}

const FirstColumn = ({ acknowledgement }) => {
    return (
        <div>
            <Link to='/' className='mra'>
                <div className='logo--main dark' />
            </Link>
            <Spacer />
            <Spacer />
            {acknowledgement && <p className='f-12 balance'>{acknowledgement}</p>}
        </div>
    )
}

const SecondColumn = ({ footer, onSubscribeClick, newsletterCta }) => {
    return (
        <div className='flex flex-col m-gap-20'>
            <span onClick={onSubscribeClick} className='p-sans f-18 pointer'>{newsletterCta}</span>
            <div className='flex f-15 gap-40 m-gap-20 m-wrap mta p-sans align-bottom m-flex-col m-align-start'>
                <div dangerouslySetInnerHTML={{ __html: footer.address }} />
                <div dangerouslySetInnerHTML={{ __html: footer.contactInfo }} />
                <div className='flex flex-col'>
                    {footer.socialMedia?.map((social, i) => (
                        <a key={i} href={social.link} target='_blank' rel='noreferrer'>{social.title}</a>
                    ))}
                </div>
            </div>
        </div>
    )
}

const MENU_ONE = [
    { label: "Why Tekt", to: "/why" },
    { label: "About Us", to: "/about" },
    { label: "Work With Us", to: "/people" },
    //{ label: "Projects", to: "/projects" },
    { label: "Our Process", to: "/process" },
    { label: "Design", to: "/design" },
]

const MENU_TWO = [
    //{ label: "News", to: "/insights" },
    //{ label: "Resources", to: "/resources" },
    { label: "Contact", to: "/contact" },
    { label: "FAQs", to: "/faqs" },
    { label: "Disclaimer & Privacy", to: "/privacy" },
]

const ThirdColumn = () => {
    return (
        <div className='flex align-bottom  m-flex-col m-align-start m-gap-20'>
            <div className='flex gap-40  m-grid-2 m-100 m-gap-20 m-wrap align-bottom'>
                <Menu items={MENU_ONE} />
                <Menu items={MENU_TWO} />
            </div>
            <CreditsToggle className='mla m-m0' />
        </div>
    )
}

const Menu = ({ items }) => (
    <div className='flex flex-col p-sans f-15'>
        {items.map(({ label, to }) => (
            <Link key={to} to={to}>{label}</Link>
        ))}
    </div>
)

const CreditsToggle = ({ className = "" }) => {
    const [showCredits, setShowCredits] = useState(false)
    return (
        <div className={`pos-rel ${className}`.trim()}>
            <span className={`p-sans f-15 pointer default credits-toggle${showCredits ? " hidden" : ""}`} onClick={() => setShowCredits(true)}>Credits</span>
            <a href='https://studiobland.com' target='_blank' rel='noreferrer' className={`p-sans f-15 credits-toggle${showCredits ? "" : " hidden"}`}>Design by Studio Bland</a>
        </div>
    )
}

const FooterMobile = ({ footer, onSubscribeClick, newsletterCta }) => {
    return (
        <div className='m-show'>
            <div className='footer-mobile flex flex-col'>
                <div className='flex flex-col gap-40 mb40'>
                    <span onClick={onSubscribeClick} className='p-sans f-18 pointer'>{newsletterCta}</span>
                    <Link to='/' className='mra'>
                        <div className='logo--main dark footer-logo-mobile' />
                    </Link>
                    <div className='footer-mobile-grid'>
                        <div className='flex flex-col f-15 p-sans gap-5'>
                            <div dangerouslySetInnerHTML={{ __html: footer.contactInfo }} />
                            <div dangerouslySetInnerHTML={{ __html: footer.address }} />
                        </div>
                        <div className='flex flex-col f-15 p-sans'>
                            {footer.socialMedia?.map((social, i) => (
                                <a key={i} href={social.link} target='_blank' rel='noreferrer'>{social.title}</a>
                            ))}
                        </div>
                    </div>
                </div>
                {footer.acknowledgement && <p className='f-12 balance mb10'>{footer.acknowledgement}</p>}
                <div className='flex gap-30'>
                    <Link className='p-sans f-15' to='/sitemap'>Sitemap</Link>
                    <CreditsToggle />
                     <Link className='p-sans f-15' to='/privacy'>Disclaimer & Privacy</Link>
                </div>
            </div>
        </div>
    )
}
